import React, { useState } from "react";
import {
  Form,
  Input,
  message,
  Button,
  Spin,
  Layout,
  Row,
  Col,
  Select,
} from "antd";
import { useMutation, useQuery } from "@apollo/client";
import { CATEGORY, UPDATE_CATEGORY } from "../../graphql/categories";
import { SUB_CATEGORIES } from "../../graphql/sub-category";
import { useParams } from "react-router";

const { Content } = Layout;

const UpdateCategory = () => {
  const { id } = useParams();
  const [form] = Form.useForm();
  const [subCategorySlug, setSubCategorySlug] = useState([]);
  const { loading, error, data } = useQuery(CATEGORY, {
    variables: {
      id,
    },
  });
  const { loading: cateLoading, data: cateData } = useQuery(SUB_CATEGORIES);
  const [updateCategory] = useMutation(UPDATE_CATEGORY);

  if (error) {
    console.error(error);
  }
  if (loading || cateLoading || !data) {
    return (
      <center>
        <Spin tip="Loading ..." />
      </center>
    );
  }
  console.log("data", data);

  const handleSubmit = (values) => {
    updateCategory({
      variables: {
        id,
        title: values.title,
        subCategoryId: values.subCategoryId,
        subCategorySlug: subCategorySlug ? subCategorySlug : [],
      },
    })
      .then(async (res) => {
        message.success(res.data.updateCategory.message);
        window.location.replace("/dashboard/product/categories");
      })
      .catch((error) => {
        let err = JSON.parse(JSON.stringify(error));
        message.error(err.graphQLErrors[0].message);
      });
  };

  return (
    <React.Fragment>
      <Content>
        <div className="contentContainer-width">
          <h1 className="header-content">Update Category</h1>
          <Form
            name="basic"
            form={form}
            layout="vertical"
            size="large"
            onFinish={handleSubmit}
            initialValues={data.category}
          >
            <Row gutter={[12, 12]}>
              <Col span={12}>
                <Form.Item
                  label="Title"
                  name="title"
                  rules={[
                    {
                      required: true,
                      message: "Please input category!",
                    },
                  ]}
                >
                  <Input className="schoolInput" />
                </Form.Item>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="button-submit"
                  >
                    Submit
                  </Button>
                </Form.Item>
              </Col>
              {/* <Col span={12}>
                <Form.Item
                  label="Main Categoy"
                  name="subCategoryId"
                  rules={[
                    {
                      required: true,
                      message: "Main Category is required!",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    // mode="multiple"
                    placeholder="Select a Main Categories"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {cateData.SubCategories.map((category) => {
                      return (
                        // eslint-disable-next-line react/jsx-no-undef
                        <Option value={category.id} key={category.id}>
                          <div
                            onClick={() => setSubCategorySlug(category.slug)}
                          >
                            {category.title}
                          </div>
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col> */}
            </Row>
          </Form>
        </div>
        <br />
      </Content>
    </React.Fragment>
  );
};

export default UpdateCategory;
